import clsx from 'clsx';

import { getMatchTypeText } from '@/modules/results/helpers';
import { Match } from '@/modules/results/types';

interface ListResultsProps {
  match?: Match;
}

export const ListResults = ({ match }: ListResultsProps) => {
  if (!match) return null;

  const gamesData = [
    {
      teamOneScore: match.team_one_game_one_score,
      teamTwoScore: match.team_two_game_one_score,
      status: match.game_one_status,
      maxScore: match.score_format_game_one_max,
      winBy: match.score_format_game_one_win_by,
    },
    {
      teamOneScore: match.team_one_game_two_score,
      teamTwoScore: match.team_two_game_two_score,
      status: match.game_two_status,
      maxScore: match.score_format_game_two_max,
      winBy: match.score_format_game_two_win_by,
    },
    {
      teamOneScore: match.team_one_game_three_score,
      teamTwoScore: match.team_two_game_three_score,
      status: match.game_three_status,
      maxScore: match.score_format_game_three_max,
      winBy: match.score_format_game_three_win_by,
    },
    {
      teamOneScore: match.team_one_game_four_score,
      teamTwoScore: match.team_two_game_four_score,
      status: match.game_four_status,
      maxScore: match.score_format_game_four_max,
      winBy: match.score_format_game_four_win_by,
    },
    {
      teamOneScore: match.team_one_game_five_score,
      teamTwoScore: match.team_two_game_five_score,
      status: match.game_five_status,
      maxScore: match.score_format_game_five_max,
      winBy: match.score_format_game_five_win_by,
    },
  ];

  const maxNoOfGames = match.score_format_game_best_out_of;
  let gamesPlayed = gamesData.reduce((count, game) => {
    if (game.teamOneScore > 0 || game.teamTwoScore > 0) return count + 1;
    return count;
  }, 0);
  if (gamesPlayed === 0) gamesPlayed = maxNoOfGames;

  const matchTypeText = getMatchTypeText(
    match.round_text,
    match.round_number,
    match.in_bracket_type
  );

  const isLiveMatch = match && match.match_status === 2;

  return (
    <div className='flex flex-col'>
      <div className='font-bold text-white sm:text-xl'>
        <span>{matchTypeText}</span>
      </div>
      <div
        className={clsx(
          'flex flex-1 flex-col items-center',
          isLiveMatch ? 'justify-start' : 'justify-center'
        )}
      >
        {isLiveMatch ? (
          <div className='flex mt-16 mb-8 py-1 px-4 sm:px-6 items-center justify-center rounded bg-error-600'>
            <div className='text-sm sm:text-base font-semibold text-white'>Live</div>
          </div>
        ) : null}
        <div className='flex items-center justify-center'>
          {match.match_completed_type === 6 ? (
            <div className='flex justify-center border-b border-b-white py-2 text-white sm:text-3xl'>
              Canceled
            </div>
          ) : (
            <ul className='mt-0 flex flex-col items-center justify-center'>
              {gamesData.slice(0, gamesPlayed).map((game) => {
                const { teamOneScore, teamTwoScore, status, maxScore, winBy } = game;

                const scoreDiff = Math.abs(teamOneScore - teamTwoScore);
                let winner: number | null = null;
                if ((teamOneScore >= maxScore || teamTwoScore >= maxScore) && scoreDiff >= winBy) {
                  winner = teamOneScore > teamTwoScore ? 1 : 2;
                } else if (teamOneScore === 0 && teamTwoScore === 0 && match.team_winner_uuid) {
                  winner = match.team_winner_uuid === match.team_one_uuid ? 1 : 2;
                }

                const teamOneTextColor = winner === 1 ? 'text-green-400' : 'text-white';
                const teamTwoTextColor = winner === 2 ? 'text-green-400' : 'text-white';

                let scoreSymbol1 = '';
                let scoreSymbol2 = '';
                if (status === '4') scoreSymbol1 = 'WD';
                else if (status === '2') scoreSymbol1 = 'FF';
                else if (status === '3') scoreSymbol1 = 'RET';

                if (status === '9') scoreSymbol2 = 'WD';
                else if (status === '7') scoreSymbol2 = 'FF';
                else if (status === '8') scoreSymbol2 = 'RET';

                return (
                  <li key={`game-${crypto.randomUUID()}`}>
                    {(teamOneScore > 0 ||
                      teamTwoScore > 0 ||
                      ['2', '3', '4', '7', '8', '9'].includes(status)) && (
                      <div
                        className={clsx(
                          'flex items-start py-2 font-bold sm:text-3xl',
                          teamOneScore && teamTwoScore ? 'border-b border-b-white' : ''
                        )}
                      >
                        <div
                          className={clsx(
                            'flex w-5 flex-col items-center justify-center sm:w-16',
                            teamOneTextColor
                          )}
                        >
                          <span>{teamOneScore}</span>
                          {scoreSymbol1 ? <span className='text-xs'>{scoreSymbol1}</span> : null}
                        </div>
                        <div className='text-white'>-</div>
                        <div
                          className={clsx(
                            'flex w-5 flex-col items-center justify-center sm:w-16',
                            teamTwoTextColor
                          )}
                        >
                          <span>{teamTwoScore}</span>
                          {scoreSymbol2 ? <span className='text-xs'>{scoreSymbol2}</span> : null}
                        </div>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
